import {
  IReplayLayer,
  IReplayTextLayer,
  IReplayVideoLayer,
  IReplayAudioLayer,
  IReplayGroupLayer,
  IReplayImageLayer,
  IReplayShapeLayer,
  IReplayVisualLayer,
} from '../types';

const isReplayTextLayer = (layer: IReplayLayer): layer is IReplayTextLayer => layer.type === 'text';
const isReplayVideoLayer = (layer: IReplayLayer): layer is IReplayVideoLayer =>
  layer.type === 'video';
const isReplayAudioLayer = (layer: IReplayLayer): layer is IReplayAudioLayer =>
  layer.type === 'audio';
const isReplayShapeLayer = (layer: IReplayLayer): layer is IReplayShapeLayer =>
  layer.type === 'shape';
const isReplayGroupLayer = (layer: IReplayLayer): layer is IReplayGroupLayer =>
  layer.type === 'group';
const isReplayImageLayer = (layer: IReplayLayer): layer is IReplayImageLayer =>
  layer.type === 'image';
const isReplayVisualLayer = (layer: IReplayLayer): layer is IReplayVisualLayer =>
  layer.type === 'visual';
const isReplayProjectLayer = (layer: IReplayLayer) => layer.mediaType === 'PROJECT_ROOT';

export {
  isReplayTextLayer,
  isReplayVideoLayer,
  isReplayAudioLayer,
  isReplayImageLayer,
  isReplayShapeLayer,
  isReplayGroupLayer,
  isReplayVisualLayer,
  isReplayProjectLayer,
};
